import { permissionKey } from 'services/user-employee-profile-permissions';
import React from 'react';
import { TemplateEmployee } from 'components/templates/template-employee';
import { API_USER_PATIENT_PROFILE_SESSIONS_CLINIC_DRUGS } from 'services/user-patient-profile-session-clinic-drugs';
import { GridModel } from './helpers';
import { createFilterEquals, mergeFilters } from 'utils/dynamic-helpers';
import { TemplateDate } from 'components/templates/template-date';

interface Options {
  userPatientProfileID: string;
}
export default (options: Options): any => ({
  store: {
    get: {
      url: API_USER_PATIENT_PROFILE_SESSIONS_CLINIC_DRUGS.GET_ALL_DYNAMIC,
      selected: [
        'isActive',
        'userPatientProfileSessionID',
        'drugID',
        'userPatientProfileSession.notebookID',
        'new { userPatientProfileSession.userEmployeeProfile.firstName, userPatientProfileSession.userEmployeeProfile.lastName } as userEmployeeProfile',
      ].join(','),
      filters: mergeFilters(
        createFilterEquals(
          'userPatientProfileSession.userPatientProfileID',
          options.userPatientProfileID,
        ),
      ).join('&&'),
    },
    create: {
      url: API_USER_PATIENT_PROFILE_SESSIONS_CLINIC_DRUGS.POST,
    },
    patch: {
      url: API_USER_PATIENT_PROFILE_SESSIONS_CLINIC_DRUGS.PATCH,
    },
    delete: {
      url: API_USER_PATIENT_PROFILE_SESSIONS_CLINIC_DRUGS.DELETE,
    },
    sortable: {
      field: 'createdDate',
      order: 'desc',
    },
  },
  controlsDropDown: [
    { type: 'delete', title: 'delete', permission: permissionKey('isAllowToDeleteAnything') },
  ],
  toolbar: {
    title: '',
    filters: null,
    controls: null,
    controlsDefault: {
      export: null,
      new: null,
    },
  },
  columns: [
    {
      title: 'entry-date',
      field: 'createdDate',
      template: (data: GridModel) => <TemplateDate date={data.createdDate} />,
      sortable: false,
    },
    {
      title: 'employee',
      field: 'id',
      sortable: false,
      template: (data: GridModel) => <TemplateEmployee employee={data.userEmployeeProfile} />,
    },
    {
      title: 'notebook',
      field: 'userPatientProfileSession.notebook.labelKey as notebookLabelKey',
      sortable: 'userPatientProfileSession.notebook.labelKey',
    },
    {
      title: 'clinic-drug',
      field: 'clinicDrug.catalogName as catalogName',
      sortable: 'clinicDrug.catalogName',
    },
    {
      title: 'dosage',
      field: 'dosageForm',
      editor: 'string',
    },
    {
      title: 'remarks',
      field: 'remarks',
      editor: 'string',
    },
  ],
});
